import { delay, Observable, of } from 'rxjs';

import { GetLocationsSelectOptionsRes } from '../models';

export function getLocationsSelectOptionsMock(): Observable<GetLocationsSelectOptionsRes> {
  return of({ locations: ['UA IT', 'CY HQ', 'KZ CS COM', 'UA CS Kyiv'] }).pipe(delay(500));
}
